export enum DataEnum {
  UNKNOWN = 'unknown',
  FILE = 'file',
  FOLDER = 'directory',
}
